type ClassNameOrFalsy = string | boolean | null | undefined | ClassNameOrFalsy[];

/**
 * Merge class names, filtering out falsy values.
 *
 * @example <Link className={clsx(linkStyle, isActive && activeLinkStyle)} />
 */
export const clsx = (...classList: ClassNameOrFalsy[]) => classList.flat().filter(Boolean).join(' ');

/**
 * Merge class names and state-based class functions into a single `(state: TState) => string` function, filtering out falsy values.\
 * Useful in combination with BaseUI components, which accept class names as a function of state.
 *
 * @example <Link className={clsxs(linkStyle, (state) => state.isActive && activeLinkStyle)} />
 */
export const clsxs =
  <TState>(...classList: (ClassNameOrFalsy | ((state: TState) => ClassNameOrFalsy))[]) =>
  (state: TState) =>
    clsx(...classList.map((className) => (typeof className === 'function' ? className(state) : className)));
